// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3YpFQ","selects":"Documents_selects__2glKh"};